module.exports = __webpack_public_path__ + "img/logo.fc4c1096.webp";